import { FC, useMemo } from 'react';

import { Icon, RyeconDatabase, RyeconListTree } from '@dbt-labs/sourdough';

import { DatabaseProvider, useDatabases } from '@/context/DatabaseProvider';
import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';
import {
  NavButtonCollapsibleGroup,
  OptionCollapsibleConfig,
} from '@/panel/NavButton/NavButtonCollapsibleGroup';
import { useSelectedSchemaFilter } from './selectedSchema';

const DatabaseFilterWithContext: FC = () => {
  const selectedSchema = useSelectedSchemaFilter();
  const projectScope = useUrlProjectParams();
  const getSchemaLink = useLinkToExplorer('schemaDetails');

  const { databaseMap } = useDatabases();

  const options = useMemo((): OptionCollapsibleConfig[] => {
    return Object.entries(databaseMap).map(([database, schemas]) => ({
      option: database,
      icon: <Icon ryecon={RyeconDatabase} />,
      label: database,
      children: schemas.map((schema) => ({
        option: schema,
        icon: <Icon ryecon={RyeconListTree} />,
        label: schema,
      })),
    }));
  }, [databaseMap]);

  return (
    <>
      <NavButtonCollapsibleGroup
        currentOption={selectedSchema}
        options={options}
        getTargetUrl={(databaseOption, schemaOption) =>
          getSchemaLink({
            ...projectScope,
            databaseName: databaseOption,
            schemaName: schemaOption,
          })
        }
      />
    </>
  );
};

export const DatabaseFilter = () => {
  return (
    <DatabaseProvider>
      <DatabaseFilterWithContext />
    </DatabaseProvider>
  );
};
